/**
 * GA4 tracking utilities.
 *
 * Events are pushed to the GTM dataLayer. GTM picks them up and forwards
 * them to GA4 via a GA4 Event tag configured in the GTM container.
 *
 * Do NOT use react-ga4's GA.initialize() or a standalone gtag.js script
 * alongside GTM — they conflict and cause events to be lost.
 */

const isProduction = window.location.hostname === "app.surmount.ai";

const pushToDataLayer = (data) => {
  if (!isProduction) {
    console.log("[GA4]", data);
  }
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};

export const trackEvent = ({ name, label, value, ...rest }) => {
  const eventName = name || "click";
  pushToDataLayer({
    event: eventName,
    label: label || document.title,
    ...(value !== undefined && { value }),
    ...rest,
  });
};

export const trackPage = (params) => {
  pushToDataLayer({
    event: "page_view",
    page_title: document.title,
    ...params,
  });
};

export const setTrackingUserId = (userId) => {
  pushToDataLayer({
    event: "set_user_id",
    user_id: userId,
  });
};
